import { Period } from './types';

export const getDateRange = ({
  period,
  year,
  quarter,
}: {
  period: Period;
  year?: number;
  quarter?: number;
}): { year: number; quarter: number; dateString: string } => {
  const now = new Date();
  const currentYear = year || now.getFullYear();

  const currentMonth = now.getMonth() + 1;
  const currentQuarter = quarter || Math.ceil(currentMonth / 3);

  let startYear: number;
  let startQuarter: number;
  let endYear: number;
  let endQuarter: number;

  switch (period) {
    case 'QUARTER': {
      startYear = currentYear;
      startQuarter = currentQuarter;

      endYear = currentYear;
      endQuarter = currentQuarter;

      break;
    }

    case 'YTD': {
      startYear = currentYear;
      startQuarter = 1;

      endYear = currentYear;
      endQuarter = currentQuarter;

      break;
    }

    case '1Y': {
      startYear = currentYear;
      startQuarter = 1;

      endYear = currentYear;
      endQuarter = 4;

      break;
    }

    default:
      throw new Error(`Unknown period: ${period}`);
  }

  return {
    year: currentYear,
    quarter: currentQuarter,
    dateString: `${startYear}/${startQuarter}/${endYear}/${endQuarter}`,
  };
};
